<span class="cdk-visually-hidden" #returnDialog i18n="@@sk-returnDialog">Return from dialog</span>
<span class="cdk-visually-hidden" #usrMesg i18n="@@sk-userMsg">User Message</span>
<span class="cdk-visually-hidden" #close i18n="@@sk-close">Close</span>
<ng-container>{{translate(returnDialog.innerHTML, usrMesg.innerHTML, close.innerHTML)}}</ng-container>


<div mat-dialog-title fxLayout="row" fxLayoutAlign="space-between center">
  <h1 class="mat-h1">{{ headerText }}</h1>
</div>
<p>{{ alertData?.message }}</p>
<div mat-dialog-actions fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="10px">
  <button
    *ngFor="let dialogButton of dialogButtons"
    mat-raised-button
    color="primary"
    (click)="onButtonClick(dialogButton)">{{ dialogButton }}</button>
</div>
